import { suppliersListingRoutes } from './features/suppliers-listing/suppliers-listing.routes';
import { suppliersDetailsRoutes } from './features/suppliers-details/suppliers-details.routes';
export const suppliersRoutes = [
  {
    path: '/suppliers',
    name: 'suppliers',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "suppliers" */ './Suppliers.vue'),
    children: [...suppliersListingRoutes, ...suppliersDetailsRoutes]
  }
];
